export const adjustExpiryDateDialogStyles = {
  container: {
    p: 3,
    width: '100%',
  },
  datePicker: {
    width: '100%',
  },
}
